import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { getAccessToken } from '../utlis/auth'
import { getServerUri } from '../utlis/config'

const ClinicContext = createContext({})

export const useClinicContext = () => {
    return useContext(ClinicContext)
}

export const ClinicProvider = ({ children }) => {
    const [clinic, setClinic] = useState(null)

    const isSuperAdminClinic = clinic?.email === "admin@gmail.com"

    const shouldUseStagingServerUri = useMemo(() => {
        return window.location.hostname === 'validation.grotech.ai'
    }, [])


    const handleFetchClinic = (accessToken) => {
        fetch(`${getServerUri()}/clinic`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken || getAccessToken()}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    setClinic(response.data)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    useEffect(() => {
        handleFetchClinic()
    }, [])

    return (
        <ClinicContext.Provider value={{ clinic, handleFetchClinic, isSuperAdminClinic, shouldUseStagingServerUri }}>
            {children}
        </ClinicContext.Provider>

    )
}

export default ClinicContext
